export default "__VITE_ASSET__BR7Cl2TS__"